import { render, staticRenderFns } from "./EmailSelector.vue?vue&type=template&id=1fbf18b5&"
import script from "./EmailSelector.vue?vue&type=script&lang=js&"
export * from "./EmailSelector.vue?vue&type=script&lang=js&"
import style0 from "./EmailSelector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports